import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

export function registerIcons(matIconRegistry: MatIconRegistry, domSanitizer: DomSanitizer) {
  matIconRegistry.addSvgIconResolver(
    (name: string) => domSanitizer.bypassSecurityTrustResourceUrl(
      `/assets/ride-wss-app/uz-icons/${name}.svg`
    )
  );
}
